import run from '../../utilities/run';
import $ from 'jquery';

run("#order-detail-page", ()=>{

 const validator = $(".address-validation-form").validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  });

  
  validator.settings.ignore = ":disabled,:hidden";
  
  const fixAddressBtn = "#order-detail-fix-add-btn";
  const order = $("#order-detail-page").data("order");
  const validateAddressUrl = $("#order-detail-page").data("validate-address-url");
  const pageReloadUrl = $("#order-detail-page").data("order-detail-page-reload-url");
  const generalErrorMessage = $("#order-detail-page").data("general-error-message");
  const addressFoundTitleText = $("#order-detail-page").data("add-validation-add-found-title-text");
  const addressNotFoundText = $("#order-detail-page").data("add-validation-system-not-found-add-text");
  const addressRevalidateTitle = $("#order-detail-page").data("add-val-modify-address-revalidate-title");

  

  $(fixAddressBtn).click(function() {
		showModal();
    	showLoadingModal();
		if(order.ordValidAddressFlag != "1") {
			addressValidation();
		} else {
			addressFoundModal(order.ordStdAddressLine1, order.ordStdAddressLine2, order.ordStdCity, 
					order.ordStdState, order.ordStdZip, order.ordStdCountry, null);			
		}
  });

  function addressValidation(){
		$.ajax({
			url: validateAddressUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				orderId: order.ordOrderId,
				callType: "addressValidation"
			},
			success: function(data){
				if(data.response == "success") {
					if(data.ordValidAddressFlag == '1') {
						addressFoundModal(data.ordStdAddressLine1, data.ordStdAddressLine2, data.ordStdCity, 
                      data.ordStdState, data.ordStdZip, data.ordStdCountry, data);
					} else {
						addressNotFoundModal(data);  
						let isChecked = $('body').find('.radio-entered-address').is(':checked');
						if(!isChecked){
							$(".use-selected-address-btn").attr("disabled", true);						
						}else{
							$(".use-selected-address-btn").attr("disabled", false);						
						}
					}
				} 
			},
			error: function(){
        	hideModal();
				alert(generalErrorMessage);
			}
		});
	}

  function addressFoundModal(stdAddress1, stdAddress2, stdCity, 
                  stdState, stdZip, stdCountry, data) {
      
      let userAddHtml = "";
      
      if(data == null) {
        userAddHtml += order.ordShipToAddress1;
        
        if(!empty(order.ordShipToAddress2)) {
          userAddHtml += ","+order.ordShipToAddress2+","+order.ordShipToCity+","+order.ordShipToState+","+order.ordShipToZip;
        } else {
          userAddHtml += ","+order.ordShipToCity+","+order.ordShipToState+","+order.ordShipToZip;
        }
      } else {
        userAddHtml = data.ordShipToAddress1;
        
        if(!empty(data.ordShipToAddress2)) {
          userAddHtml += ","+data.ordShipToAddress2+","+data.ordShipToCity+","+data.ordShipToState+","+data.ordShipToZip;
        } else {
          userAddHtml += ","+data.ordShipToCity+","+data.ordShipToState+","+data.ordShipToZip;
        }
      }

      $("#add-validation-user-entered-add").html(userAddHtml);
      
      let sysAddHtml = stdAddress1;
      if(!empty(stdAddress2)) {
        sysAddHtml += ","+stdAddress2+","+stdCity+","+stdState+","+stdZip;
      } else {
        sysAddHtml += ","+stdCity+","+stdState+","+stdZip;
      }

      $("#add-validation-system-found-add").html(sysAddHtml);
      showAddressFoundModal();
	}

	function addressNotFoundModal(data) {
		
		let userAddHtml = data.ordShipToAddress1;
		if(!empty(data.ordShipToAddress2)) {
			userAddHtml += ","+data.ordShipToAddress2+","+data.ordShipToCity+","+data.ordShipToState+","+data.ordShipToZip;
		} else {
			userAddHtml += ","+data.ordShipToCity+","+data.ordShipToState+","+data.ordShipToZip;
		}
		
		$("#add-validation-user-entered-add").html(userAddHtml);
		showAddressNotFoundModal();
	}

	$('.mod-address-btn').click(function(){
    	showLoadingModal();
		$.ajax({
			url: validateAddressUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				orderId: order.ordOrderId,
				callType: "modifyAddress"
			},
			success: function(data){
				if(data.response == "success") {
					const countries = data.countries;
						
					$('#validate-address-country').empty();
					let option = $('<option />');
					option.attr('value', '').text("Select Country");
					$('#validate-address-country').append(option);
					$(countries).each(function() {
						option = $('<option />');
						option.attr('value', this.conCode).text(this.conName);
						$('#validate-address-country').append(option);
					});

					let userAddHtml = data.ordShipToAddress1;
					
					if(!empty(data.ordShipToAddress2)) {
						userAddHtml += ","+data.ordShipToAddress2+","+data.ordShipToCity+","+data.ordShipToState+","+data.ordShipToZip;
					} else {
						userAddHtml += ","+data.ordShipToCity+","+data.ordShipToState+","+data.ordShipToZip;
					}
					$("#add-validation-user-entered-add").html(userAddHtml);					
					$(".origin-modify-enter-address-item").hide();
					showModifyAddressModal();
				} 
			},
			error: function(){
        	hideModal();
				alert(generalErrorMessage);
			}
		});
	});

	


	$('#validate-address-country').change(function(){
		const countryVal = $("#validate-address-country :selected").val();
		setStatesFromCountry(countryVal, this.selectedIndex);
	});

	function setStatesFromCountry(countryVal, selectedIndex) {

    	if(countryVal == "US" || countryVal == "CA") {
			$(".validate-address-state-text-wrapper").hide();
			$(".validate-address-state-wrapper").show();
			window.print_state("validate-address-state", selectedIndex);
		} else {
			$(".validate-address-state-text-wrapper").show();
			$(".validate-address-state-wrapper").hide();
		}
	}

	$('.use-selected-address-btn').click(function(){
    	showLoadingModal();
		$.ajax({
			url: validateAddressUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				orderId: order.ordOrderId,
				userSelectedAdd: $('[name=radioAddressChoice]:checked').val(),
				callType: "usethisAddress"
			},
			success: function(data){
				if(data.response == "success" &&
						data.isAddFixed) {
					location.href=(pageReloadUrl);
				} 
			},
			error: function(){
        		hideModal();
				alert(generalErrorMessage);
			}
		});
	});
  
  $('.validate-address-btn').click(function(){
    
    if(!validator.elements().valid()) {
      return;
    }
    
    showLoadingModal();
    
    const conCode = $("#validate-address-country :selected").val();
    let stateValue = "";
    if(conCode == "US" || conCode == "CA") {
      stateValue = $("#validate-address-state :selected").val();
    } else {
      stateValue = $("#validate-address-state-text").val();
    }
    
		$.ajax({
			url: validateAddressUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				orderId: $('#orderId').val(),
				country: conCode,
				address1: $("#validate-address-address1").val(),
				address2: $("#validate-address-address2").val(),
				city: $("#validate-address-city").val(),
				state: stateValue,
				zip: $("#validate-address-zip").val(),
				callType: "validateThisAddress"
			},
			success: function(data){
				if(data.response == "success") {
					if(data.isAddFixed) {
						location.href=(pageReloadUrl);
					} else if(data.ordValidAddressFlag == "1") {
            		  addressFoundModal(data.ordStdAddressLine1, data.ordStdAddressLine2, data.ordStdCity, 
                      data.ordStdState, data.ordStdZip, data.ordStdCountry, data);
					} else {
						addressNotFoundModal(data);
					}
				}
			},
			error: function(){
        		hideModal();
				alert(generalErrorMessage);
			}
		});
	});
  

  function showLoadingModal(){
		$("#address-found-or-not-text").html("");
		$(".add-validation").show();
		$(".origin-add-validation").hide();
    $(".address-select-choices-outer").hide();
		$(".address-validation-loading-outer").show();
		$(".cancel-btn").hide();
		$(".mod-address-btn").show();
		$(".select-saved-address-btn").hide();
    $(".use-selected-address-btn").hide();
    $(".validate-address-btn").hide();
  }

  function showModal() {
    $("#add-validation-model").modal("show");
  }

  function hideModal() {
    $("#add-validation-model").modal("hide");
  }
  
  function showAddressFoundModal() {
    $("#address-found-or-not-text").html(addressFoundTitleText);
    if($("#radio-entered-address").hasClass("q-radio-hide")) {
      $("#radio-entered-address").removeClass("q-radio-hide");
		}
		$(".add-validation").show();
    $(".address-select-choices-outer").show();
		$(".found-address-item").show();
		$(".enter-address-item").show();
    $(".modify-address-section").hide();
    $(".no-address-found-section").hide();
    $(".address-validation-loading-outer").hide();
		$(".mod-address-btn").show();
    $(".use-selected-address-btn").show();
    $(".validate-address-btn").hide();
  }
  
  function showAddressNotFoundModal() {
    $("#address-found-or-not-text").html(addressNotFoundText);
    if($("#radio-entered-address").hasClass("q-radio-hide")) {
      $("#radio-entered-address").removeClass("q-radio-hide");
		}
		$(".add-validation").show();
    $(".address-select-choices-outer").show();
		$(".found-address-item").hide();
		$(".enter-address-item").show();
    $(".modify-address-section").hide();
    $(".no-address-found-section").show();
    $(".address-validation-loading-outer").hide();
		$(".mod-address-btn").show();
	$(".use-selected-address-btn").show();	
    $(".validate-address-btn").hide();
  }
  
  function showModifyAddressModal() {
    $("#address-found-or-not-text").html(addressRevalidateTitle);
    $("#radio-entered-address").addClass("q-radio-hide");
		$(".address-select-choices-outer").show();
		$(".add-validation").show();
		$(".found-address-item").hide();
		$(".enter-address-item").show();
    $(".modify-address-section").show();
    $(".no-address-found-section").hide();
    $(".address-validation-loading-outer").hide();
		$(".mod-address-btn").hide();
    $(".use-selected-address-btn").hide();
    $(".validate-address-btn").show();
  }
  
  function empty(str) {
	    if (typeof str == 'undefined' || !str || str.length === 0 || str === "" ||
	    		!/[^\s]/.test(str) || /^\s*$/.test(str) || str.replace(/\s/g,"") === "") {
	        return true;
      } else {
	        return false;
	    }
	}

	$(document).on('click', '.radio-entered-address', function (e) {
		addressNotFoundValidationModal();
	});

	function addressNotFoundValidationModal() {
		let isChecked = $('body').find('.radio-entered-address').is(':checked');
		let stubmitBtn = $('body').find('.use-selected-address-btn');

		if (isChecked) {
			stubmitBtn.attr("disabled", false);
		} else {
			stubmitBtn.attr("disabled", true);
		}
	}
	 
	addressNotFoundValidationModal();  
});


// WEBPACK FOOTER //
// ./src/pages/order/detailAddressValidation.js